import {
    Shirt, Gem, UtensilsCrossed, Plane, ShoppingBag, Tv, HeartPulse, Smartphone,
    ShoppingBasket, Hotel, Watch, Lamp, Crown, BookOpen, Car, Dumbbell, Building2,
    Sparkles, Palette, Briefcase, Music, Gift,
} from "lucide-react";

// Maps a backend category name → { icon, color1, color2 }
const MAP = {
    "Apparel":                       { Icon: Shirt,          c1: "#0B1437", c2: "#1a2455" },
    "Jewellery":                     { Icon: Gem,            c1: "#C9A959", c2: "#A07E2C" },
    "Food & Beverage":               { Icon: UtensilsCrossed,c1: "#E11D48", c2: "#9F1239" },
    "Travel":                        { Icon: Plane,          c1: "#0EA5E9", c2: "#075985" },
    "Hotels":                        { Icon: Hotel,          c1: "#7C3AED", c2: "#5B21B6" },
    "Online Shopping":               { Icon: ShoppingBag,    c1: "#F97316", c2: "#C2410C" },
    "Entertainment & Subscriptions": { Icon: Tv,             c1: "#DB2777", c2: "#9D174D" },
    "Health & Wellness":             { Icon: HeartPulse,     c1: "#16A34A", c2: "#166534" },
    "Electronics":                   { Icon: Smartphone,     c1: "#0891B2", c2: "#155E75" },
    "Groceries":                     { Icon: ShoppingBasket, c1: "#65A30D", c2: "#3F6212" },
    "Accessories":                   { Icon: Watch,          c1: "#A16207", c2: "#713F12" },
    "Home & Furniture":              { Icon: Lamp,           c1: "#92400E", c2: "#451A03" },
    "Luxury":                        { Icon: Crown,          c1: "#C9A959", c2: "#854D0E" },
    "Books":                         { Icon: BookOpen,       c1: "#7C2D12", c2: "#431407" },
    "Mobility":                      { Icon: Car,            c1: "#0F766E", c2: "#134E4A" },
    "Sports":                        { Icon: Dumbbell,       c1: "#0F172A", c2: "#1E293B" },
    "Marketplace":                   { Icon: Building2,      c1: "#475569", c2: "#1E293B" },
    "Watches":                       { Icon: Watch,          c1: "#A16207", c2: "#713F12" },
    "Beauty":                        { Icon: Palette,        c1: "#DB2777", c2: "#9D174D" },
    "Fashion":                       { Icon: Shirt,          c1: "#0B1437", c2: "#1A2455" },
    "Kids":                          { Icon: Gift,           c1: "#F97316", c2: "#C2410C" },
    "Subscriptions":                 { Icon: Music,          c1: "#7C3AED", c2: "#5B21B6" },
    "Eyewear":                       { Icon: Briefcase,      c1: "#0891B2", c2: "#155E75" },
    "Health":                        { Icon: HeartPulse,     c1: "#16A34A", c2: "#166534" },
    "Fintech":                       { Icon: Briefcase,      c1: "#0B1437", c2: "#1A2455" },
    "Entertainment":                 { Icon: Tv,             c1: "#DB2777", c2: "#9D174D" },
    "Donations":                     { Icon: Gift,           c1: "#16A34A", c2: "#166534" },
    "Experiences":                   { Icon: Sparkles,       c1: "#7C3AED", c2: "#5B21B6" },
};

export function CategoryIcon({ name, size = 24 }) {
    const m = MAP[name] || { Icon: Sparkles, c1: "#0B1437", c2: "#1A2455" };
    const { Icon, c1, c2 } = m;
    return (
        <div
            style={{ background: `linear-gradient(135deg, ${c1}, ${c2})`, width: size + 24, height: size + 24 }}
            className="rounded-2xl flex items-center justify-center text-white shadow-[0_6px_16px_-6px_rgba(11,20,55,0.30)]"
            data-testid={`cat-icon-${name}`}
        >
            <Icon size={size} strokeWidth={2.2} />
        </div>
    );
}

export function getCategoryColors(name) {
    return MAP[name] || { c1: "#0B1437", c2: "#1A2455" };
}
